<template>
    <div class="main">
        <el-container class="container">
            <el-header class="header" style="height: 50px;">
                <div class="header-box">
                    <div class="logo">
                        <router-link to="/">
                            <img src="../assets/images/logo-white.png" style="height:30px;margin-top:10px;">
                        </router-link>
                    </div>
                    <div class="content">
                        <div class="bra-box">
                            <div class="item">
                              <a href="https://t.me/zhuzhuxia1881" target="_blank"> 客服飞机： @zhuzhuxia1881  </a>
                              <a href="https://t.me/xiaomo556677" target="_blank"> 客服飞机： @xiaomo556677 </a>
                              <a href="http://wpa.qq.com/msgrd?v=3&uin=3920572477&site=qq&menu=yes" target="_blank"> 客服QQ一：3920572477  </a>
                              <a href="http://wpa.qq.com/msgrd?v=3&uin=3683390325&site=qq&menu=yes" target="_blank">  客服QQ二: 3683390325 </a>
                            </div>


                            <div class="item">
                                <router-link to="/tabs/flowRecharge">
                                    <span > 购买访问包</span>
                                </router-link>
                            </div>
                            <div class="item">
                                <router-link to="/tabs/buyDomain">
                                    <span> 购买专属域名</span>
                                </router-link>
                            </div>
                            <!--                            <div class="item">-->
                            <!--                                <router-link to="/tabs/buyDomain">-->
                            <!--                                    <i class="el-icon-receiving fs-20"></i>-->
                            <!--                                    <span> APP下载</span>-->
                            <!--                                </router-link>-->
                            <!--                            </div>-->
                            <div class="item">
                                <router-link to="/tabs/vipRecharge">
                                    <span> 升级VIP</span>
                                </router-link>
                            </div>
                            <div class="item">
                              <router-link to="/tabs/charge">
                                <span> 余额：{{userInfo.money}}</span>
                              </router-link>
                            </div>
                        </div>
                        <div class="user-info">
                            <div class="profile"><el-avatar icon="el-icon-user-solid" :size="'medium'" :src="userInfo.profile"></el-avatar></div>
                            <div class="nickname">
                                <i class="iconfont iconVIP vip-icon" v-show="isVip"></i>
                                <span>{{userInfo.nickname}}</span>
                            </div>
                            <div class="dropdown-box">
                                <ul class="dropdown-menu">
                                    <li class="dropdown-item">
                                        <router-link to="/tabs/userInfo">
                                            <i class="iconfont iconyonghu"></i>
                                            <span>个人中心</span>
                                        </router-link>
                                    </li>
                                    <li class="dropdown-item" v-if="userInfo.is_certification==1">
                                        <router-link to="/tabs/certification">
                                            <i class="iconfont icon-dwzanquan"></i>
                                            <span v-if="userInfo.is_certification==1">已认证√</span>
                                            <span v-else class="red">未认证</span>
                                        </router-link>
                                    </li>
                                    <li class="dropdown-item" @click="loginOut">
                                        <i class="iconfont icontuichu"></i>
                                        <span>退出登入</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="message">
                            <el-badge :value="msgNum" :max="99" class="item" :hidden="!msgNum"><i class="el-icon-bell"></i></el-badge>
                            <div class="msg-list">
                                <div class="pm-list">
                                    <ul>
                                        <li class="text-align" v-show="msgList.length">您有以下未读消息</li>
                                        <li class="av" v-for="item in msgList" @click="goMsg(item.pm_id)">
                                            <div class="ellipsis">{{item.pm_title}}</div>
                                            <div class="fs-12">{{item.post_date}}</div>
                                        </li>
                                        <li class="no-msg" v-show="!msgList.length">暂时没有未读消息</li>
                                    </ul>
                                    <div class="btn-box" v-show="msgList.length">
                                        <span @click="allRead">全部已读</span>
                                        <span><router-link to="/tabs/message">查看更多</router-link></span>
                                    </div>
                                    <div class="btn-box fs-16" v-show="!msgList.length">
                                        <router-link to="/tabs/message">消息中心</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-header>
            <el-container class="containers">
                <el-aside style="width: 200px">
                    <div style="position: relative;border-bottom: 1px solid #eee;margin-bottom: 20px;">
                        <span style="position: absolute;left: 15px;top:-8px;content:'';width: 4px;height: 20px;background-color: #0f9fff;"></span>
                        <span style="margin-left: 30px;position: relative;top:-12px;font-size: 20px;font-weight: bold;">功能菜单</span>
                    </div>
                    <el-menu class="menu" :default-active="$route.path" :router="true">
                      <el-menu-item index="/tabs/buyDomain"><i class="iconfont ">🔥</i>购买专属域名</el-menu-item>
                        <el-menu-item index="/tabs/shortUrlList"><i class="iconfont icon-dwzmenu"></i>短网址列表</el-menu-item>
                        <el-menu-item index="/tabs/stat"><i class="iconfont icon-dwzmenu"></i>数据统计</el-menu-item>
                        <el-menu-item index="/tabs/index"><i class="iconfont icon-dwzRectangleCopy11"></i>转换短网址</el-menu-item>
                        <el-menu-item index="/tabs/liveCodeList"><i class="iconfont icon-dwzerweima1"></i>活码管理</el-menu-item>
                      <el-menu-item index="/tabs/xcx/link"><i class="iconfont icon-dwzRectangleCopy35"></i>小程序短链接</el-menu-item>
                        <el-menu-item index="/tabs/webPageList"><i class="iconfont icon-dwzh5-qudao"></i>h5单页创作</el-menu-item>
                        <el-menu-item index="/tabs/exclusiveShort"><i class="iconfont icon-dwzzhuanshutequan"></i>专属域名转换</el-menu-item>
                        <!--                        <el-menu-item index="/tabs/shopGoods"><i class="iconfont icon-dwztongbushoucang2"></i>淘宝短链接</el-menu-item>-->

                        <el-menu-item index="/tabs/domainOrder"><i class="iconfont icon-dwzRectangleCopy35"></i>域名交易记录</el-menu-item>
                        <el-menu-item index="/tabs/exclusiveDomain"><i class="iconfont icon-dwzmenu"></i>我的专属域名</el-menu-item>
                        <el-menu-item index="/tabs/longurl"><i class="iconfont icon-dwzmenu"></i>专属中间域名</el-menu-item>
                        <el-menu-item index="/tabs/exclusiveDomain2"><i class="iconfont icon-dwzmenu"></i>专属域名监控</el-menu-item>
                        <el-menu-item index="/tabs/ckUrlList"><i class="iconfont icon-dwzlanjie"></i>网址监控列表</el-menu-item>
                        <!--                        <el-menu-item index="/tabs/vipContrast"><i class="iconfont icon-dwztiaojie"></i>套餐对比</el-menu-item>-->
                        <el-menu-item index="/tabs/vipRecharge"><i class="iconfont icon-dwzRectangleCopy6"></i>充值VIP</el-menu-item>
                        <!--                        <el-menu-item index="/tabs/flowRecharge"><i class="iconfont icon-dwzRectangleCopy5"></i>购买访问包</el-menu-item>-->
                        <el-menu-item index="/tabs/flowList"><i class="iconfont icon-dwzmenu"></i>我的访问包</el-menu-item>
                        <el-menu-item index="/tabs/userInfo"><i class="iconfont icon-dwzyonghu"></i>个人中心</el-menu-item>
                        <!--                            <el-menu-item index="/tabs/editPass">登入密码</el-menu-item>-->
                        <el-menu-item index="/tabs/userToken"><i class="iconfont icon-dwzAPI"></i>Token</el-menu-item>

                    </el-menu>
                </el-aside>
                <el-container>
                    <el-main class="tabs-main">
                        <div class="boxs">
                            <transition name="fade" mode="out-in">
                                <router-view></router-view>
                            </transition>
                        </div>
                    </el-main>
                    <el-footer class="footer">
                        <div>Copyright © 2018  版权所有</div>
                    </el-footer>
                </el-container>
            </el-container>
        </el-container>

    </div>


</template>

<script>

    export default {
        name: "Tabs",
        data() {
            return {
                isVip: false,
                msgNum: 0,
                msgList: [],
                userInfo: {
                    uid: "",
                    profile: "",
                    nickname: "",
                    expire_date: "",
                    ustate:1,
                },
            }
        },
        mounted() {
            const times = Date.parse(new Date())/1000;

            this.getMsgList();
            this.getUserInfo();

        },
        methods: {
            async getUserInfo() {
                const {ret,data} = await this.$api.user.getUserInfo();
                if (ret === 1000){
                    this.userInfo = data;
                    this.$common.userInfo=data;
                    this.isVip=this.userInfo.isVip;

                }
            },
            async getMsgList() {
                const res = await this.$api.notice.overview();
                if (res.ret === 1000){
                    this.msgNum = res.data.number;
                    this.msgList = res.data.list;
                }
            },
            async allRead() {
                const res = await this.$api.notice.readAll();
                if (res.ret === 1000){
                    this.getMsgList();
                    this.$message.success('操作成功');
                }
            },
            loginOut() {
                this.$common.loginOut();
            },
            goMsg(id) {
                this.$router.push({
                    name: 'message',
                    params: {
                        id: id
                    }
                })
            },
        },
    }
</script>

<style scoped>
    .main{
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }
    .header{
        padding: 0;
        background-color: #333;
    }
    .header-box{
        width: 100%;
        height: 100%;
        margin: 0 auto;
        padding-left: 200px;
        position: relative;
        background-color: #333;
    }
    .header-box .logo{
        width: 130px;

        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
        margin-left: 20px;
    }
    .header-box .content{
        width: 100%;
        height: 100%;
        text-align: right;
    }
    .header-box .content .message{
        display: inline-block;
        width: 50px;
        height: 50px;
        text-align: left;
        padding-top: 15px;
        padding-left: 28px;
        cursor: pointer;
        vertical-align: top;
        position: relative;
    }
    .header-box .content .message i{
        color: #ccc;
        font-size: 22px;
    }
    .header-box .content .message:hover .msg-list{
        display: block;
        pointer-events:auto;
    }
    .header-box .content .user-info{
        display: inline-block;
        width: auto;
        height: 60px;
        text-align: left;
        padding-top: 5px;
        padding-left: 20px;
        cursor: pointer;
        position: relative;
        margin-right: 200px;
    }
    .header-box .content .user-info .profile{
        display: inline-block;
        width: 40px;
        height: 100%;
        margin-right: 10px;
        vertical-align: top;
    }
    .header-box .content .user-info .nickname{
        display: inline-block;
        width: auto;
        height: 40px;
        color: #ccc;
        line-height: 40px;
        vertical-align: top;
    }
    .header-box .content .user-info .nickname .vip-icon{
        color: red;
        margin-right: 5px;
    }
    .header-box .content .user-info:hover .nickname{
        color: #008df2;
    }
    .header-box .content .user-info:hover .dropdown-box{
        display: block;
        pointer-events:auto;
    }
    .header-box .content .bra-box{
        display: inline-block;
        height: 30px;
        margin-top: 5px;
        padding-top: 10px;
        border-right: 1px solid #666;
        vertical-align: top;
    }
    .header-box .content .bra-box .item{
        color: #666666;
        display: inline-block;
        margin-right: 30px;
        vertical-align: top;
    }
    .header-box .content .bra-box .item a{
        color: #ccc;
    }
    .header-box .content .bra-box .item a:hover{
        color: #fff;
    }
    .footer{
        color: #666666;
        text-align: center;
    }
    .container{
        height: 100%;
    }
    .containers{
        width: 100%;
        margin: 0 auto;
    }
    .tabs-main{
        padding-right: 0;
    }
    .el-aside{
        height: calc(100% - 100px);
        margin-top: 20px;
        padding-top: 20px;
        background-color: #ffffff;
    }
    .el-aside .el-main{
        height: 100%;
        background: #ffffff;
    }
    .el-avatar{
        border: 1px solid #C0C4CC;
    }
    .boxs{
        width: 100%;
        min-height: 835px;
        background-color: #ffffff;
    }
    .menu{
        border: 0;
    }
    .dropdown-box{position:absolute;top:40px;right:0;z-index:1000;padding-top: 10px;background-color: transparent;pointer-events: none;display: none;}
    .dropdown-box .dropdown-menu{padding: 5px 0;font-size: 14px;background-color:#fff;box-shadow: 0 2px 8px rgba(0,0,0,.15);border-radius: 4px;}
    .dropdown-box .dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}
    .dropdown-box .dropdown-menu .dropdown-item{display:block;min-width: 106px;padding: 5px 12px;color:#212529;background-color:transparent;border:0;cursor:pointer;}
    .dropdown-box .dropdown-menu .dropdown-item a{color:#212529;}
    .dropdown-box .dropdown-menu .dropdown-item i{display: inline-block;vertical-align: middle;margin-right: 12px;}
    .dropdown-box .dropdown-menu .dropdown-item span{display: inline-block;vertical-align: middle;}
    .dropdown-box .dropdown-menu .dropdown-item:hover{color:rgba(0,0,0,.65);;text-decoration:none;background-color:#e6f7ff}
    .msg-list{width: 230px;position: absolute;top: 40px;right: 0;padding-top: 10px;background-color: transparent;z-index:1000;pointer-events: none;display: none;}
    .msg-list .pm-list{width: 100%;background-color: #ffffff;box-shadow: 0 2px 8px rgba(0,0,0,.15);border-radius: 4px;overflow: hidden;}
    .msg-list ul li{display:block;width: calc(100% - 24px);padding: 5px 12px;color:#212529;font-size: 14px;border-bottom: 1px solid #e8e8e8;}
    .msg-list ul li.no-msg{line-height: 40px;text-align: center;color: rgba(0,0,0,.65);}
    .msg-list ul li.av:hover{background-color: #e6f7ff;cursor:pointer;}
    .msg-list .pm-list .btn-box{width: 100%;height: 40px;font-size: 16px;color: rgba(0,0,0,.65);padding: 0;cursor:pointer;text-align: center;line-height: 40px;}
    .msg-list .pm-list .btn-box a{color: rgba(0,0,0,.65);}
    .msg-list .pm-list .btn-box span{display: inline-block;width: 50%;height: 100%;line-height: 40px;font-size: 14px;vertical-align: top;}
    .msg-list .pm-list .btn-box span:last-child {width: calc(50% - 1px);border-left: 1px solid #e8e8e8;}
    .msg-list .pm-list .btn-box span:hover{background-color: #e6f7ff;}
    .msg-list .pm-list .btn-box.fs-16:hover{background-color: #e6f7ff;}
    .ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
    .fs-12{font-size: 12px;}
    .fs-20{font-size: 20px;}


    .kk2{position: relative;}
    .kk2 div{position: absolute;top:40px;left:0px;display: none;z-index: 99;}
    .kk2:hover div{display: block;}
</style>
